// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"HomePage-module__pageContainer___3czqN","resultContainer":"HomePage-module__resultContainer___3ojnx","searchContainer":"HomePage-module__searchContainer___NiNmh","search__content":"HomePage-module__search__content___1gXBc","search__field":"HomePage-module__search__field___3Ksc8","search__position":"HomePage-module__search__position___2Pe-J","search__icon":"HomePage-module__search__icon___2or1T","homePageContainer":"HomePage-module__homePageContainer___29Xbr"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/HomePage/HomePage.module.css
// module id = 631
// module chunks = 0